import React, { useEffect } from 'react';
import Header from './Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Portfolio from './components/Portfolio';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Education from './components/Education';
import Contact from './components/Contact';
import Footer from './components/Footer';

import "./styles/style.css";
import "./styles/bootstrap.min.css";
import "./styles/slick.css";
import "./styles/slick-theme.css";
import "./styles/aos.css";
import "./styles/feature.css";

function Body() {
	useEffect(() => {
		// Initialize AOS or other scripts if needed
		if (window.AOS) {
			window.AOS.init();
		}
	}, []);

	return (
		<div className="template-color-1 spybody" data-spy="scroll" data-target=".navbar-example2" data-offset="70">
			<Header />
			<main className="main-page-wrapper">
				<Hero />
				<Features />
				<Portfolio />
				<Experience />
				<Skills />
				<Education />
				<Contact />
				<Footer />
			</main>
		</div>
	);
}

export default Body;
